/**
 * WebSocket authentication (E5b; risks R-301, R-302).
 *
 * A browser cannot set an Authorization header on a WebSocket, and a
 * `?token=` query string would be written to the server's access log. So the
 * socket offers two subprotocols, `["qyngent.auth", <jwt>]`. The server echoes
 * `qyngent.auth` and closes with 4401 (no or bad token) or 4403 (not your
 * project). Those closes are final: a retry would be refused again.
 */
import { getAuthToken } from '@/lib/api'

export const WS_AUTH_SUBPROTOCOL = 'qyngent.auth'

const FINAL_CLOSE_CODES = [4401, 4403]

/** The subprotocols to open a socket with, or null when signed out (open none). */
export function wsAuthProtocols(): string[] | null {
  const token = getAuthToken()
  return token ? [WS_AUTH_SUBPROTOCOL, token] : null
}

/** True when a close code means "do not reconnect". */
export function isFinalWsClose(code: number, extra: number[] = []): boolean {
  return FINAL_CLOSE_CODES.includes(code) || extra.includes(code)
}
